import './App.css';
import { Route, Routes } from 'react-router';
import { HashRouter } from 'react-router-dom';
import HomePage from './pages/HomePage';
import { ConfigProvider } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'antd/dist/antd.css';
import Header from './components/Header/Header';
import Notification from './pages/Notification';
import Footer from './components/Footer';
import NotificationDetail from './components/NotificationDetail';
import ContactUs from './pages/ContactUs';
import Download from './pages/Download';
import ScrollToTop from './common/ScrollToTop';


function App() {

  return (
    <ConfigProvider locale={zh_CN}>
      <HashRouter>
      <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
        <Header></Header>
        <ScrollToTop></ScrollToTop>
        <Routes>
          <Route path='/' element={<HomePage />}></Route>
          <Route path='/notification' element={<Notification />}></Route>
          <Route path='/notification/:id' element={<NotificationDetail />}></Route>
          <Route path='/download' element={<Download width='960px' />}></Route>
          <Route path='/contact' element={<ContactUs />}></Route>
        </Routes>
        <Footer></Footer>
      </div>
      </HashRouter>
    </ConfigProvider>
  )
}

export default App
